<template>
  <div class="d-flex">
    <div @click="iconStateWeb($event)" :class="{ pointer: !!pushToRouteName }">
      <i :class="`${icon} fs-20 mr-2`"></i>
      <span class="font-weight-bold fs-18">
        {{ text }}
        <i v-if="pushToRouteName" class="fas fa-external-link-alt ml-2"></i>
      </span>
      <b-badge v-if="comingSoon" variant="warning" class="ml-2">Em breve</b-badge>
      <i
        v-if="isSectionWeb"
        :class="`${
          !isSectionOpenWeb ? 'fas fa-angle-up' : 'fas fa-angle-down'
        } ml-2`"
      ></i>
      </div>
      <div @click="iconStateApp($event)">
        <i
          v-if="isSectionApp"
          :class="`${
            !isSectionOpenApp ? 'fas fa-angle-down' : 'fas fa-angle-up'
          } ml-2`"
        ></i>
      </div>
  </div>
  
</template>
<script>
export default {
  name: 'Topic',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    pushToRouteName: {
      type: String,
      required: false,
    },
    comingSoon: {
      type: Boolean,
      default: false,
    },
    isSectionWeb: {
      type: Boolean,
      default: false,
    },
    isSectionApp: {
      type: Boolean,
      default: false,
    },
    validAssinatura: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isSectionOpenWeb: false,
      isSectionOpenApp: false,
    };
  },

  created() {
    this.isSectionOpenWeb = localStorage.getItem("iconStateWeb");
    this.isSectionOpenApp = localStorage.getItem("iconStateApp");
  },

  methods: {
    iconStateWeb($event) {
      if(this.validAssinatura == true) {
        this.isSectionOpenWeb = !this.isSectionOpenWeb;
        this.isSectionOpenApp = !this.isSectionOpenApp;
        if(this.isSectionOpenWeb == false) {
          this.isSectionOpenWeb = false;
          localStorage.removeItem("iconStateWeb");
        }
        if (this.isSectionOpenWeb == true) {
        localStorage.setItem("iconStateWeb", true)
        this.isSectionOpenWeb = true;
      }
    }
    this.pushTo()
    this.$emit('click', $event);
    },

    iconStateApp($event) {
      if(this.validAssinatura == true) {
        this.isSectionOpenApp = !this.isSectionOpenApp;
        if(this.isSectionOpenApp == false) {
          this.isSectionOpenApp = false;
          localStorage.removeItem("iconStateApp");
        }
        if (this.isSectionOpenApp == true) {
        localStorage.setItem("iconStateApp", true)
        this.isSectionOpenApp = true;
      }
    }
    this.$emit('click', $event);
    },

    pushTo() {
      if(this.validAssinatura == true) {
        if (this.$route.name === this.pushToRouteName) return;

        this.$router.push({ name: this.pushToRouteName });
      }
    },
  },
};
</script>
